<mat-toolbar class="subtitulo">Cadastro Aprendiz</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            
            <div fxLayout="column" fxFlex="60%">
                <mat-toolbar class="titulopartes">Beneficiário</mat-toolbar>
                <div ngModelGroup="comboBeneficiario" fxFlex="100" fxLayoutGap="20px" style="padding-top: 15px;">
                    <combo-beneficiario [showDisplayId]="false" 
                                        [obrigatorio]="true" 
                                        [selecionado]="filtro.aluno"
                                        (valorChange)="onValorChange($event)">
                    </combo-beneficiario>
                </div>
            </div>
            
            <div fxLayout="column" fxFlex="35%">
                <mat-toolbar class="titulopartes">Data</mat-toolbar>
                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
                    <mat-form-field fxFlex="48%" style="margin-left: 20px" >
                        <input  matInput name="dataInicioAlunoTrabalhando"
                            [matDatepicker]="dataInicioAlunoTrabalhando" placeholder="Data Início:"
                            [(ngModel)]="alunoTrabalhando.dataInicioAlunoTrabalhando" >
                        <mat-datepicker-toggle matSuffix [for]="dataInicioAlunoTrabalhando"></mat-datepicker-toggle>
                        <mat-datepicker #dataInicioAlunoTrabalhando></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field fxFlex="48%">
                        <input matInput name="dataFimAlunoTrabalhando" [matDatepicker]="dataFimAlunoTrabalhando"
                            placeholder="Data Fim:" [(ngModel)]="alunoTrabalhando.dataFimAlunoTrabalhando" (input)="onMascaraDataInput($event)">
                        <mat-datepicker-toggle matSuffix [for]="dataFimAlunoTrabalhando"></mat-datepicker-toggle>
                        <mat-datepicker #dataFimAlunoTrabalhando></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div *ngIf="alunoTrabalhando.aluno?.id">
            <dados-aluno [aluno]=alunoTrabalhando.aluno></dados-aluno>
        </div>


        <mat-toolbar class="titulopartes">Empreendimento</mat-toolbar>

        <div fxLayout="row" fxLayoutGap="50px"  fxFlexFill>
            <mat-form-field fxFlexOffset="20px" fxFlex="100%">
                <mat-label>Empresa:</mat-label>
                <mat-select [(ngModel)]="alunoTrabalhando.empresa.id" 
                            name="empresa" 
                            required>
                    <mat-option></mat-option>
                    <mat-option *ngFor="let i of empresas" [value]="i.id">
                        {{i.nomeFantasia}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="alunos?.length === 0" align="start">Nenhuma empresa cadastrada</mat-hint>
            </mat-form-field>
        </div>


        <div fxLayout="row" fxLayoutGap="50px"  fxFlexFill>
            <mat-form-field fxFlexOffset="20px"  fxFlex="45%">
                <input #nomeEmpreendimento matInput maxlength="200" 
                       name="numeroAulas" 
                       placeholder="Nome do empreendimento:"
                       [(ngModel)]="alunoTrabalhando.nomeEmpreendimento">
                <mat-hint align="end">{{nomeEmpreendimento.value.length}} / 200</mat-hint>
            </mat-form-field>

            <mat-form-field style="margin: 0 0 0 20px" fxFlex="45%" appearance="outline">
                <mat-label>Descrição diagnóstico:</mat-label>
                <textarea #observacoes matInput name="observacoes" [(ngModel)]="alunoTrabalhando.descTipoEmpreendimento" cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="200">
                </textarea>
                <mat-hint align="end">{{observacoes.value.length}} / 200</mat-hint>
            </mat-form-field>
        </div>

        <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
            fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
            </button>

            <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                Atualizar
            </button>

            <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                Limpar
            </button>
            <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                Cancelar
            </button>

        </div>
    </form>

</div>
